import Highcharts from 'highcharts';
import { COLORS } from '../utils/colorGenerator';

Highcharts.setOptions({
  colors: COLORS,
  lang: {
    thousandsSep: ',',
  },
  // The following styles are v10 defaults
  // https://www.highcharts.com/blog/news/highcharts-version-11/
  chart: {
    style: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '16px',
    },
  },
  title: {
    style: {
      fontWeight: 'normal',
      fontSize: '18px',
    },
  },
  plotOptions: {
    area: {
      lineWidth: 2,
    },
    column: {
      borderRadius: 0,
    },
    pie: {
      borderRadius: 0,
      dataLabels: {
        connectorShape: 'fixedOffset',
      },
    },
    line: {
      lineWidth: 2,
    },
    spline: {
      lineWidth: 2,
    },
  },
  tooltip: {
    borderWidth: '1',
  },
  legend: {
    itemStyle: {
      fontWeight: 'bold',
    },
  },
  xAxis: {
    labels: {
      distance: 8,
      style: {
        color: '#666666',
        fontSize: '11px',
      },
    },
    lineColor: '#ccd6eb',
  },
  yAxis: {
    labels: {
      distance: 8,
      style: {
        color: '#666666',
        fontSize: '11px',
      },
    },
  },
  scrollbar: {
    barBorderRadius: 0,
    barBorderWidth: 1,
    buttonsEnabled: true,
    height: 14,
    margin: 0,
    rifleColor: '#333',
    trackBackgroundColor: '#f2f2f2',
    trackBorderRadius: 0,
  },
});
